module.exports = __webpack_public_path__ + "img/wearable_0.8a086a2e.jpg";